"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FundRedemptConfirm = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var zl_1 = require("../../model/zl");
var service_1 = require("../../../library/base/service");
var FundRedemptConfirm = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(FundRedemptConfirm, _super);
    function FundRedemptConfirm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '详情页基金赎回';
        _this.code = '106009';
        _this.desc = '详情页基金赎回';
        _this.requestParams = new zl_1.FundRedemptConfirmRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return FundRedemptConfirm;
}(service_1.BaseService));
exports.FundRedemptConfirm = FundRedemptConfirm;
//# sourceMappingURL=fundRedemptConfirm.js.map